<template>
  <div class="block-content flex flex-col items-start">
    <transition
      @before-enter="onBeforeEnter"
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @before-leave="onBeforeLeave"
      @leave="onLeave"
      mode="out-in"
    >
      <div v-if="!isExpanded" class="block-content__preview mt-4">
        <p ref="preview" class="text-body-2 text-blue-700" v-html="content" />
      </div>
      <p
        v-else
        class="text-body-2 text-blue-700 mt-4"
        :class="{
          'block-content__paragraph': true,
          'block-content__paragraph--is-expanded': isExpanded,
        }"
        v-html="content"
      />
    </transition>
    <f3-button
      v-show="!isExpanded"
      id="team-button-<?php echo $index; ?>-open"
      rounded
      square
      class="button-team animated text-button-2 font-bold uppercase is-blue-100 mt-2"
      type="button"
      @click="toggleContent('open')"
    >
      <span class="text-blue-900 icon-add"></span>
    </f3-button>
    <f3-button
      v-show="isExpanded"
      id="team-button-<?php echo $index; ?>-close"
      rounded
      square
      class="button-team text-button-2 font-bold uppercase is-blue-100 mt-2"
      type="button"
      @click="toggleContent('close')"
    >
      <span class="text-blue-900 icon-remove"></span>
    </f3-button>
  </div>
</template>

<script>
import eventHub from '../helpers/event-hub'

export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    visibleLines: {
      type: Number,
      default: 4
    },
  },
  data () {
    return {
      lineHeight: 20,
      isExpanded: false,
      isToggleButtonRequired: true,
      previewHeight: 0
    }
  },
  created () {
  },
  beforeDestroy () {
  },
  computed: {
    maxHeightCollapsed() {
      return this.lineHeight * this.visibleLines
    },
  },
  mounted() {
    this.previewHeight = (this.$refs.preview ?? {}).clientHeight ?? 0;
    this.isToggleButtonRequired = this.previewHeight > this.maxHeightCollapsed;
  },
  methods: {
    onBeforeEnter (el) {
      el.style.height = "80px";
    },
    onEnter (el, done) {
      el.style.height = el.scrollHeight + "px";
      done()
    },
    onAfterEnter (el) {
      el.style.overflow = "hidden";
    },
    onBeforeLeave (el) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.overflow = "hidden";
    },
    onLeave (el) {
      el.style.height = "80px";
      el.style.overflow = "hidden";
    },
    toggleContent(action) {
      this.isExpanded = !this.isExpanded
      if (action === 'close') {
        document.querySelector('#section-team').scrollIntoView();
      }
    }
  }
}
</script>

<style>
/* purgecss start ignore */
.block-content {
  gap: 8px;
}
.block-content__preview {
  /* default line-height is 20px */
  max-height: calc(20px * v-bind(visibleLines));
  overflow: hidden;
}
.block-content__paragraph {
  overflow: hidden;
  transition: all 250ms ease-out;
}
.block-content__paragraph.block-content__paragraph--is-expanded {
  overflow: initial;
}
.block-content__button {
  text-decoration: underline;
  align-self: flex-start;
}
/* purgecss end ignore */
</style>